import { isUrl } from '~/components/utils/browser/url';

const getDefaultProps = (width, height, fill, cropAuto, extendedProps = {}) => {
  return Object.values({
    width: width && `w_${width}`,
    hegiht: height && height !== 'auto' && `h_${height}`,
    q_auto: 'q_auto',
    f_auto: false && 'f_auto', // disable until cloudinary will fix problem
    c_fill: fill && 'c_fill',
    c_fit: !fill && 'c_fit',
    g_auto: cropAuto && 'g_auto',
    ...extendedProps,
  }).filter(Boolean);
};

const getCloudinaryUrl = (imgUrl, props) => {
  return `https://res.cloudinary.com/bravado/image/fetch/${props.join(',')}/${imgUrl}`;
};

export const src = (imgUrl, width, height, fill, cropAuto) => {
  if (!isUrl(imgUrl)) return imgUrl;

  const props = getDefaultProps(width, height, fill, cropAuto);
  return getCloudinaryUrl(imgUrl, props);
};

export const srcSet = (imgUrl, width, height, fill, cropAuto) => {
  if (!isUrl(imgUrl)) return imgUrl;

  return [
    `${src(imgUrl, width * 3, height * 3, fill, cropAuto)} 3x`,
    `${src(imgUrl, width * 2, height * 2, fill, cropAuto)} 2x`,
    `${src(imgUrl, width, height, fill, cropAuto)} 1x`,
  ].join(', ');
};

export const srcAvatarImage = (imgUrl, width, height, fill, cropAuto, cloudinaryParams = {}) => {
  if (!isUrl(imgUrl)) return imgUrl;

  const props = getDefaultProps(width, height, fill, cropAuto, {
    q_auto: 'q_auto:best',
    e_sharpen: 'e_sharpen:100',
    ...cloudinaryParams,
  });

  return getCloudinaryUrl(imgUrl, props);
};

export const srcSetAvatarImage = (imgUrl, width, height, fill, cropAuto, cloudinaryParams = {}) => {
  if (!isUrl(imgUrl)) return imgUrl;

  return [
    `${srcAvatarImage(imgUrl, width * 3, height * 3, fill, cropAuto, cloudinaryParams)} 3x`,
    `${srcAvatarImage(imgUrl, width * 2, height * 2, fill, cropAuto, cloudinaryParams)} 2x`,
    `${srcAvatarImage(imgUrl, width, height, fill, cropAuto, cloudinaryParams)} 1x`,
  ].join(', ');
};

export const srcCommentImage = (imgUrl, isExpandedComment = false, size = 1) => {
  const width = 700;
  const height = 258;

  let maxHeight = height;
  let fitProp = 'c_fit';

  if (isExpandedComment && process.client && window) {
    maxHeight = window.innerHeight * 0.9;
    fitProp = 'c_limit';
  }

  const props = [`ar_${width}:${height}`, `h_${maxHeight * size}`, fitProp];
  return getCloudinaryUrl(imgUrl, props);
};

export const srcSetCommentImage = (imgUrl, isExpandedComment) => {
  return [
    `${srcCommentImage(imgUrl, isExpandedComment, 3)} 3x`,
    `${srcCommentImage(imgUrl, isExpandedComment, 2)} 2x`,
    `${srcCommentImage(imgUrl, isExpandedComment)} 1x`,
  ].join(', ');
};

export const srcCompanyImage = (imgUrl, size) => {
  const props = [`w_${size}`, `h_${size}`, `c_pad`, 'f_jpg'];
  return getCloudinaryUrl(imgUrl, props);
};
